<template>
  <div class="expert-page" v-loading="pageLoading">
    <div class="expert-shell">
      <div class="expert-card">
        <div class="exam-select-row">
          <div class="label">请选择您的培训班</div>
          <el-select
            v-model="selectedErId"
            class="exam-select"
            :disabled="isExamSelectDisabled"
            placeholder="请选择培训班"
            @change="onExamChange"
          >
            <el-option
              v-for="item in displayExamOptions"
              :key="item.erId"
              :label="item.name"
              :value="item.erId"
              :disabled="item.disabled === true"
            />
          </el-select>
        </div>

        <div class="main-row">
          <div class="qr-column">
            <img class="qr-frame" :src="assets.expertBox" alt="二维码边框" />
            <div class="qr-inner">
              <vue-qr
                v-if="hasSelectedApply"
                class="qr-code-image"
                :text="qrCodeText"
                :size="130"
                :margin="1"
                colorDark="#20b8b5"
                colorLight="#ffffff"
              />
              <img
                v-else
                class="qr-placeholder"
                :src="assets.qrPlaceholder"
                alt="暂无考试二维码占位"
              />
            </div>
          </div>

          <div class="action-grid">
            <button class="action-card" type="button" @click="openManualDialog">
              <img
                :src="assets.practiceManual"
                alt="实践手册"
                class="action-icon"
              />
              <span class="action-title">实践手册</span>
            </button>

            <button class="action-card" type="button" @click="goToCheckRecord">
              <img
                :src="assets.testRecord"
                alt="考核记录"
                class="action-icon"
              />
              <span class="action-title">考核记录</span>
            </button>

            <button
              class="action-card"
              type="button"
              @click="handleExpertAction"
            >
              <img
                :src="assets.expertAuth"
                alt="专家认证"
                class="action-icon"
              />
              <span class="action-title">{{ expertActionTitle }}</span>
            </button>

            <button
              class="action-card"
              type="button"
              @click="openProcessDialog"
            >
              <img
                :src="assets.expertProcess"
                alt="专家操作流程"
                class="action-icon"
              />
              <span class="action-title">专家操作流程</span>
            </button>
          </div>
        </div>

        <div class="note-text">
          注：请先选择您的培训班，已认证的专家通过“e护考培”APP扫描上方二维码后进行技能考核
        </div>
      </div>
    </div>

    <el-dialog
      :title="manualDialogTitle"
      :visible.sync="manualDialogVisible"
      width="920px"
      append-to-body
      custom-class="expert-rich-dialog"
    >
      <div class="rich-content" v-loading="manualLoading">
        <div v-if="manualContent" v-html="manualContent"></div>
        <el-empty v-else description="暂无内容" :image-size="90" />
      </div>
    </el-dialog>

    <el-dialog
      :title="processDialogTitle"
      :visible.sync="processDialogVisible"
      width="920px"
      append-to-body
      custom-class="expert-rich-dialog"
    >
      <div class="rich-content" v-loading="processLoading">
        <div v-if="processContent" v-html="processContent"></div>
        <el-empty v-else description="暂无内容" :image-size="90" />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { httpRequest } from "@/axios/axios-api";
import vueQr from "vue-qr";
import practiceManualPng from "@/assets/expert/PracticeManual.png";
import testRecordPng from "@/assets/expert/testRecord.png";
import expertAuthPng from "@/assets/expert/expertAuth.png";
import expertProcessPng from "@/assets/expert/zhuanjiacaozuo.png";
import expertBoxPng from "@/assets/expert/expert_box.png";
import qrPlaceholderPng from "@/assets/expert/qrCodePlaceholderImage.png";

export default {
  name: "Expert",
  components: {
    vueQr
  },
  data() {
    return {
      pageLoading: false,
      examOptions: [],
      selectedErId: -1,
      selectedExam: null,
      fixedErId: null,
      userInfo: {},
      manualDialogVisible: false,
      manualDialogTitle: "实践手册",
      manualContent: "",
      manualLoading: false,
      processDialogVisible: false,
      processDialogTitle: "专家操作流程",
      processContent: "",
      processLoading: false,
      assets: {
        practiceManual: practiceManualPng,
        testRecord: testRecordPng,
        expertAuth: expertAuthPng,
        expertProcess: expertProcessPng,
        expertBox: expertBoxPng,
        qrPlaceholder: qrPlaceholderPng
      }
    };
  },
  computed: {
    hasSelectedApply() {
      return !!(
        this.selectedExam &&
        this.selectedExam.apply &&
        this.selectedExam.apply.arId
      );
    },
    qrCodeText() {
      if (!this.hasSelectedApply) {
        return "";
      }
      return `${this.selectedExam.apply.arId},ehkp`;
    },
    displayExamOptions() {
      if (this.examOptions.length > 0) {
        return this.examOptions;
      }
      return [
        {
          erId: -1,
          name: "暂无考试",
          disabled: true
        }
      ];
    },
    isExamSelectDisabled() {
      return this.fixedErId !== null || this.examOptions.length === 0;
    },
    expertStatus() {
      const raw = this.userInfo ? this.userInfo.expertStatus : null;
      const parsed = Number(raw);
      if (!Number.isNaN(parsed) && parsed >= 0) {
        return parsed;
      }
      if (this.parseTruthy(this.userInfo ? this.userInfo.isExpert : false)) {
        return 2;
      }
      return 0;
    },
    expertActionTitle() {
      if (this.expertStatus === 1) {
        return "认证审核中";
      }
      if (this.expertStatus === 2) {
        return "已认证专家";
      }
      return "专家认证";
    }
  },
  created() {
    this.initPage();
  },
  methods: {
    async initPage() {
      this.pageLoading = true;
      this.fixedErId = this.parsePositiveInt(this.$route.query.erId);
      try {
        await Promise.all([
          this.loadUserInfo(),
          this.loadPracticeExams(),
          this.preloadExpertProcess()
        ]);
      } finally {
        this.pageLoading = false;
      }
    },
    parsePositiveInt(value) {
      const num = Number(value);
      if (Number.isNaN(num) || num <= 0) {
        return null;
      }
      return num;
    },
    parseTruthy(value) {
      if (value === true || value === 1 || value === "1") {
        return true;
      }
      if (typeof value === "string") {
        return value.toLowerCase() === "true";
      }
      return false;
    },
    getExamMajorId(exam) {
      if (!exam) {
        return 0;
      }
      if (exam.majorId) {
        return exam.majorId;
      }
      if (exam.major && exam.major.majorId) {
        return exam.major.majorId;
      }
      return 0;
    },
    async loadUserInfo() {
      try {
        const res = await httpRequest("/app/user", "get", null);
        if (res && res.code === 200) {
          this.userInfo = res.data || {};
        }
      } catch (error) {
        void error;
      }
    },
    async loadPracticeExams() {
      try {
        const res = await httpRequest(
          "/app/exam/exam/can-practice-exams",
          "get",
          null
        );
        if (!(res && res.code === 200 && Array.isArray(res.data))) {
          this.examOptions = [];
          this.selectedErId = -1;
          this.selectedExam = null;
          return;
        }

        this.examOptions = res.data;
        if (this.examOptions.length === 0) {
          this.selectedErId = -1;
          this.selectedExam = null;
          return;
        }

        let current = this.examOptions[0];
        if (this.fixedErId !== null) {
          const matched = this.examOptions.find(
            item => Number(item.erId) === this.fixedErId
          );
          if (matched) {
            current = matched;
          }
        }

        this.selectedExam = current;
        this.selectedErId = current.erId;
      } catch (error) {
        void error;
        this.examOptions = [];
        this.selectedErId = -1;
        this.selectedExam = null;
      }
    },
    onExamChange(erId) {
      if (erId === -1) {
        this.selectedExam = null;
        return;
      }
      const matched = this.examOptions.find(
        item => Number(item.erId) === Number(erId)
      );
      this.selectedExam = matched || null;
    },
    async preloadExpertProcess() {
      try {
        const res = await httpRequest("/app/news/zjczlc", "get", null);
        if (res && res.code === 200 && res.data) {
          this.processDialogTitle = res.data.title || "专家操作流程";
          this.processContent = res.data.content || "";
        }
      } catch (error) {
        void error;
      }
    },
    async openManualDialog() {
      if (!this.selectedExam || Number(this.selectedErId) === -1) {
        this.$message.warning("暂无考试");
        return;
      }

      const majorId = this.getExamMajorId(this.selectedExam);
      if (!majorId) {
        this.$message.warning("暂无考试");
        return;
      }

      this.manualDialogTitle = "实践手册";
      this.manualContent = "";
      this.manualDialogVisible = true;

      this.manualLoading = true;
      try {
        const res = await httpRequest(`/app/major/${majorId}`, "get", null);
        if (res && res.code === 200 && res.data) {
          this.manualDialogTitle = res.data.name || "实践手册";
          this.manualContent = res.data.practiceOutline || "";
        }
      } finally {
        this.manualLoading = false;
      }
    },
    async openProcessDialog() {
      this.processDialogVisible = true;
      if (this.processContent) {
        return;
      }

      this.processLoading = true;
      try {
        const res = await httpRequest("/app/news/zjczlc", "get", null);
        if (res && res.code === 200 && res.data) {
          this.processDialogTitle = res.data.title || "专家操作流程";
          this.processContent = res.data.content || "";
        }
      } finally {
        this.processLoading = false;
      }
    },
    goToCheckRecord() {
      if (!this.hasSelectedApply) {
        this.$message.warning("暂无考试");
        return;
      }
      if (!this.canOpenEvaluationRecord(this.selectedExam)) {
        const practiceRange = this.getPracticeRangeText(this.selectedExam);
        if (practiceRange) {
          this.$message.warning(`暂未开启，实践考核时间：${practiceRange}`);
        } else {
          this.$message.warning("暂未开启");
        }
        return;
      }
      this.$router.push({
        path: "/evaluationRecord",
        query: {
          arId: this.selectedExam.apply.arId
        }
      });
    },
    canOpenEvaluationRecord(exam) {
      const start = this.parseDateTime(exam && exam.practiceStartTime);
      if (!start) {
        return true;
      }
      return Date.now() >= start.getTime();
    },
    getPracticeRangeText(exam) {
      const startText = this.formatDateTime(exam && exam.practiceStartTime);
      const endText = this.formatDateTime(exam && exam.practiceEndTime);
      if (!startText || !endText) {
        return "";
      }
      return `${startText}~${endText}`;
    },
    parseDateTime(value) {
      if (!value) {
        return null;
      }
      if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
      }
      const normalized = String(value).replace(/-/g, "/");
      const parsed = new Date(normalized);
      if (!Number.isNaN(parsed.getTime())) {
        return parsed;
      }
      const fallback = new Date(value);
      return Number.isNaN(fallback.getTime()) ? null : fallback;
    },
    formatDateTime(value) {
      const date = this.parseDateTime(value);
      if (!date) {
        return "";
      }
      const year = date.getFullYear();
      const month = `${date.getMonth() + 1}`.padStart(2, "0");
      const day = `${date.getDate()}`.padStart(2, "0");
      const hour = `${date.getHours()}`.padStart(2, "0");
      const minute = `${date.getMinutes()}`.padStart(2, "0");
      const second = `${date.getSeconds()}`.padStart(2, "0");
      return `${year}-${month}-${day} ${hour}:${minute}:${second}`;
    },
    handleExpertAction() {
      if (this.expertStatus === 1) {
        this.$message.info("您已提交认证，请等待审核");
        return;
      }

      if (this.expertStatus === 2) {
        this.$message.info("您已认证为专家");
        return;
      }

      this.$router.push("/expertCertification");
    }
  }
};
</script>

<style scoped lang="scss">
.expert-page {
  padding: 18px 0 10px;

  .expert-shell {
    width: 1000px;
    max-width: calc(100% - 40px);
    margin: 0 auto;
  }

  .expert-card {
    background: #ffffff;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(17, 31, 57, 0.04);
    padding: 30px 40px 40px;
  }

  .exam-select-row {
    display: flex;
    align-items: center;
    gap: 20px;
    padding-bottom: 24px;
    border-bottom: 1px dashed #edf0f4;

    .label {
      min-width: 140px;
      font-size: 17px;
      color: #1f2530;
      text-align: left;
      line-height: 1;
      font-weight: 500;
    }

    .exam-select {
      flex: 1;
      min-width: 0;
    }
  }

  .main-row {
    margin-top: 30px;
    display: grid;
    grid-template-columns: 200px 1fr;
    gap: 40px;
    align-items: start;
  }

  .qr-column {
    position: relative;
    width: 196px;
    height: 196px;

    .qr-frame {
      width: 196px;
      height: 196px;
      display: block;
      object-fit: cover;
    }

    .qr-inner {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      width: 130px;
      height: 130px;
      border-radius: 8px;
      background: #ffffff;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

    .qr-placeholder {
      width: 130px;
      height: 130px;
      object-fit: contain;
      opacity: 0.95;
    }

    .qr-code-image {
      width: 130px !important;
      height: 130px !important;
      display: block;
      border-radius: 4px;
    }
  }

  .action-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 20px;
    margin-top: 8px;
  }

  .action-card {
    height: 84px;
    border: 1px solid #e1e5eb;
    border-radius: 8px;
    background: #f8fafc;
    box-shadow: 0 2px 4px rgba(24, 39, 75, 0.02);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 16px;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(23, 39, 74, 0.08);
      border-color: #3f93dc;
      background: #ffffff;
    }

    &:active {
      transform: translateY(0);
      box-shadow: 0 2px 6px rgba(24, 39, 75, 0.06);
    }

    .action-icon {
      width: 42px;
      height: 42px;
      object-fit: contain;
      flex-shrink: 0;
    }

    .action-title {
      font-size: 20px;
      color: #2b303b;
      line-height: 1;
      font-weight: 500;
      white-space: nowrap;
    }
  }

  .note-text {
    margin-top: 24px;
    text-align: left;
    font-size: 14px;
    line-height: 1.6;
    color: #8f959d;
    background: #f8fafc;
    padding: 12px 16px;
    border-radius: 6px;
  }
}

.rich-content {
  max-height: 62vh;
  overflow: auto;
  text-align: left;
  padding-right: 6px;
}

::v-deep .expert-rich-dialog {
  border-radius: 14px;
  overflow: hidden;

  .el-dialog__header {
    padding: 18px 24px 16px;
    border-bottom: 1px solid #edf0f4;
  }

  .el-dialog__title {
    color: #1d2430;
    font-size: 20px;
    font-weight: 600;
  }

  .el-dialog__body {
    padding: 18px 24px 24px;
  }

  img {
    max-width: 100% !important;
    height: auto !important;
  }

  table {
    width: 100% !important;
  }
}

@media (max-width: 1100px) {
  .expert-page {
    .main-row {
      grid-template-columns: 1fr;
      gap: 20px;
    }

    .qr-column {
      margin: 0 auto;
    }

    .action-grid {
      grid-template-columns: 1fr;
    }

    .action-card {
      height: 88px;
      justify-content: flex-start;
      padding: 0 20px;
    }

    .note-text {
      margin-top: 20px;
      font-size: 15px;
    }
  }
}
</style>
